import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import styled from 'styled-components';
import { Scroll } from 'common/components/base/scroll';

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            maxWidth: '700px',
            backgroundColor: theme.palette.background.paper,
            '& .MuiListItemIcon-root': {
                minWidth: 'initial',
            },
            '& .leftIcon': {
                width: 70,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                '& img': {
                    marginLeft: '-20px',
                },
            },
            '& .Mui-selected': {
                '& .MuiListItemIcon-root': {
                    color: '#02AE81',
                },
            },
            '& .MuiTypography-colorTextSecondary': {
                color: '#777777',
            },

            '& .MuiListItemText-primary': {
                fontWeight: 500,
                fontSize: 18,
            },
            '& .Mui-selected .MuiListItemText-primary': {
                color: '#02AE81',
            },
            '& .Mui-selected .MuiTypography-colorTextSecondary': {
                color: '#02AE81',
            },
            '& .MuiListItem-root': {
                border: '1px solid #dddddd',
                marginBottom: 10,
                '& :hover': {
                    '& .MuiListItemText-primary': {
                        color: '#02AE81',
                    },
                    '& .MuiTypography-colorTextSecondary': {
                        color: '#02AE81',
                    },
                },
                '&.Mui-selected': {
                    border: '1px solid #02AE81',
                },
            },
            '& .checkIcon': {
                minMidth: 'initial',
                justifyContent: 'flex-end',
                marginTop: '-25px',
            },
        },
        listItem: {
            maxWidth: '450px',
        },
    })
);

const ContentScroll = styled(Scroll)`
    overflow-y: auto;
    height: calc(100% - 48px);
`;

export { ContentScroll };
